export const clickOutsideDirective = {
  beforeMount(el: any, binding: any) {
    el.clickOutsideEvent = (evt: any) => {
      evt.stopPropagation();
      if (!(el === evt.target || el.contains(evt.target))) {
        // Check if the click occurred outside the panel and v-overlay is not open(added to handle v-datepicker, v-select and v-multiselect scenarios)
        if (!el.contains(evt.target) && !evt.target.closest('.v-overlay-container')) {
          binding.value(evt, el);
        }
      }
    };
    window.requestAnimationFrame(() => {
      document.addEventListener('click', el.clickOutsideEvent);
    });
  },
  unmounted(el: any) {
    document.removeEventListener('click', el.clickOutsideEvent);
  },
};
